import {
  getIsInVendorSRPLinkExperiment,
  triggerSrpLinkExperimentViewed,
} from '@/components/util/srpLinkExperimentHelpers';
import cx from 'classnames';
import { UserContext } from '@zola-helpers/client/dist/types/@types';
import BabyFooter from '@zola/zola-ui/src/components/footers/baby/BabyFooter/BabyFooter';
import { PreauthFooterV3 } from '@zola/zola-ui/src/components/PreAuthV3';
import { useLocationForVendorSRPLink } from '@zola/zola-ui/src/hooks/useLocationForVendorSRPLink/useLocationForVendorSRPLink';
import { useShopContext } from '@/contexts/shop/ShopContext/ShopContext';

export const Footer = ({ userContext }: { userContext: UserContext | null }) => {
  const { isBaby } = useShopContext();

  const isGuest = userContext ? Boolean(userContext.is_guest) : true;
  const isInSRPExperiment = getIsInVendorSRPLinkExperiment(userContext);

  const weddingLocation = useLocationForVendorSRPLink({
    isInSRPExperiment: isInSRPExperiment || false,
  });

  if (isBaby) return <BabyFooter />;

  return (
    <div className={cx({ postAuthNav3Padding: !isGuest })}>
      <PreauthFooterV3
        weddingLocation={weddingLocation}
        isGuest={isGuest}
        marketplacePostAuthLinkOnClick={() => {
          triggerSrpLinkExperimentViewed(userContext);
        }}
      />
    </div>
  );
};
